module.exports = __webpack_public_path__ + "2803115b414f88ab80d1f14e14c5fa72.png";